import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { ConsultantService } from '../../../core/services/person/consultant/consultant.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatProgressBar } from '@angular/material/progress-bar'
import { ConsultantClientEditFormComponent } from './consultant-client-form/consultant-client-edit-form.component'
import {
  phoneTransform,
  responseDefaultForm,
} from '../../../shared/utils/utils'
import { TelefonePipe } from '../../../shared/pipes/phone.pipes'

@Component({
  selector: 'consultant-client-edit',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    MatProgressBar,
    ConsultantClientEditFormComponent,
    TelefonePipe,
  ],
  templateUrl: './consultant-client-edit.component.html',
  styleUrl: './consultant-client-edit.component.scss',
  providers: [ConsultantService],
  standalone: true,
})
export class ConsultantClientEditComponent implements OnInit, AfterViewInit {
  constructor(
    private consultantService: ConsultantService,
    private snackbar: SnackbarCustomService,
  ) {}

  item: any = {}
  loading: boolean = true

  @Output() response: EventEmitter<any> = new EventEmitter()
  @Input() idClient: number = 0
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'name',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'email',
      key: 'email',
      description: 'Email',
    },
    {
      keyColumn: 'phone',
      key: 'telefone',
      description: 'Telefone',
    },
    {
      keyColumn: 'birth',
      key: 'dataNascimento',
      description: 'Data Nascimento',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]

  page: number = 1
  rows: number = 10
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = ['name', 'email', 'phone', 'birth', 'action']

  inputSearchConsultant: any = { type: '', search: '' }
  listSearch: any = [
    { id: 'nome', description: 'Nome', type: 'string', visible: true },
    { id: 'email', description: 'Email', type: 'string', visible: true },
    {
      id: 'nascimento',
      description: 'Nascimento',
      type: 'date',
      visible: false,
    },
    { id: 'telefone', description: 'Telefone', type: 'string', visible: true },
  ]
  searchForm: any = { search: false, model: {} }

  ngOnInit(): void {
    this.getConsultantByPerson()
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    // if (this.table) {
    //   this.table.renderRows()
    // }
  }

  pageChanged($event: any) {
    this.page = $event.pageIndex + 1
    // this.rows = $event.pageSize
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchConsultant()
    } else {
      this.getConsultantByPerson()
    }
  }

  getConsultantByPerson() {
    this.loading = true
    this.consultantService
      .listPagedConsultantByPerson(this.idClient, this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchConsultant() {
    this.loading = true
    this.consultantService
      .searchPagedConsultant(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push({
          ...item,
          telefone_transform: phoneTransform(item.telefone),
        })
      }
    }
    this.tableSource = new MatTableDataSource<any>(list)
    this.refreshTable()
  }

  responseForm(response: any): void {
    if (response.refresh) {
      this.uploadList()
    }
    if (response.clear) {
      this.clearItem()
    }
  }

  updateItem(element: any) {
    this.item = { edit: true, data: element }
  }

  deleteItem(element: any) {
    this.clearItem()
    this.consultantService.deleteConsultant({ id: element.id }).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  clearItem() {
    this.item = {}
  }

  createModel(element: any) {
    let model: any = { clienteId: this.idClient }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }
}
